import React, { useContext } from 'react';
import { getContext } from 'common';
import { SelectItemBasicContext } from './SelectItemBasic';
import Styled from './styles';

export interface SelectItemBaseIconProps extends React.ComponentPropsWithRef<'div'> {
  /** Children, consider using Icon component. */
  children?: React.ReactNode;
}

/** Icon item to display in a SelectItem base element.
 * Any other props will be provided to the wrapper element.
 */
const SelectItemBaseIcon = React.forwardRef<HTMLElement, SelectItemBaseIconProps>((props: SelectItemBaseIconProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    ...otherProps
  } = props;
  const selectItemBasicContext = useContext(SelectItemBasicContext);
  const resolvedTheme = selectItemBasicContext.variant === 'outlined' ? theme.TEXT_INPUT.OUTLINED : theme.TEXT_INPUT.UNDERLINED;
  return (
    <Styled.SelectItemBaseIcon
      ref={ref}
      RTL={RTL}
      $theme={resolvedTheme}
      disabled={selectItemBasicContext.disabled}
      {...otherProps}
    >
      {children}
    </Styled.SelectItemBaseIcon>
  );
}));

SelectItemBaseIcon.displayName = 'SelectItemBaseIcon';

SelectItemBaseIcon.defaultProps = {
  children: undefined,
};

export { SelectItemBaseIcon as default };
